import { type Channel } from './Channel'
import { isRealtimeAvailable } from './realtimeInstance'
import { usePrevioRealtime } from './usePrevioRealtime'

/** What the backend hands out in its authenticated "current user" response. */
export type RealtimeCredentials = {
  userChannel: string
  namespace: string
  key: string
}

let userChannel: Channel | null = null

/**
 * The channel is shared between the P2 applications, so the namespace comes from the backend instead
 * of this app's own component name. A no-op when the plugin was not installed: realtime is optional
 * and sign-in must not depend on it.
 */
export const initUserRealtime = (credentials: RealtimeCredentials): Channel | null => {
  if (!isRealtimeAvailable()) {
    return null
  }

  if (userChannel?.name === credentials.userChannel) {
    return userChannel
  }

  const { setKey, subscribe } = usePrevioRealtime()

  userChannel?.unsubscribe()
  setKey(credentials.key)
  userChannel = subscribe(credentials.userChannel, credentials.namespace)

  return userChannel
}

export const useUserRealtime = (): Channel | null => userChannel

/** Call on logout so the user key does not outlive the session. */
export const disconnectUserRealtime = (): void => {
  if (!userChannel) {
    return
  }

  const { setKey, disconnect } = usePrevioRealtime()

  userChannel = null
  setKey(null)
  disconnect()
}
